import { root } from './historical-web-events';

export const historicalWebEvents = {
  ...root,
};
